import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { useStyleConfig, Box } from '@chakra-ui/react';
import { Droppable as Droppable$1 } from 'react-beautiful-dnd';
var Droppable = function Droppable(_ref) {
  var children = _ref.children,
    droppableId = _ref.droppableId;
  var styles = useStyleConfig('DropZoneStyle');
  return /*#__PURE__*/React.createElement(Box, {
    __css: styles
  }, /*#__PURE__*/React.createElement(Droppable$1, {
    droppableId: droppableId
  }, function (provided) {
    return /*#__PURE__*/React.createElement(Box, _extends({}, provided.droppableProps, {
      ref: provided.innerRef,
      __css: styles
    }), children(provided), provided.placeholder);
  }));
};
Droppable.displayName = "Droppable";
export { Droppable };